import { Injectable, Inject } from '@angular/core';

import { baseStyle, iconTypes, iconWeights } from 'msteams-ui-icons-core';
import { Colors, IContext, getContext, ThemeStyle, primaryButton } from 'msteams-ui-styles-core'
import { style } from 'typestyle/lib'

@Injectable({
  providedIn: 'root'
})
export class MsTeamsContextProvider {


  constructor() { }

  public getContext(): IContext {
    return this.getMsTeamsConext();
  }


  private getMsTeamsConext() {
    //const { Colors, IContext, getContext, ThemeStyle } = require('msteams-ui-styles-core')
    // This is the styling function from typestyle


    // This function is optional. The default one will use Typestyle.
    // 'name' is the advised potential name of the class, your function can ignore this and return anything.
    // 'cssProperties' is the object containing the css properties to generate the class from.
    const cssFunction = (name, ...cssProperties) => {
      // default typestyle styling function.
      return style(...cssProperties);
    }

    const config = {
      // This is the root font size in pixels specified at the HTML element.
      baseFontSize: 16,
      // Other options: ThemeStyle.Light, ThemeStyle.Dark, ThemeStyle.HighContrast
      style: ThemeStyle.Light,
      // Optional; default = Teams colors; You can customize the colors here, however changing this will deviate from
      // the MS Teams guidelines.
      colors: Colors,
      // Optional; default = typestyle; This function takes a style object compatible with Typestyle, should perform
      // whatever is required to materialize the CSS style, and return the name of the CSS class generated.
      css: cssFunction,
    };

    return getContext(config);
  }


  
}
